import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue' // added
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import AcryProRegistMailAddress from '../views/AcryProRegistMailAddress.vue'
import AcryProForgotPassword from '../views/AcryProForgotPassword.vue'
import AcryProContract from '../views/AcryProContract.vue'
import AcryProForm from '../views/AcryProForm.vue'
import ContactForm from '../views/ContactForm.vue'
import ContactFormComplete from '../views/ContactFormComplete.vue'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import { Analytics } from "@/js/Analytics.js";

Vue.use(VueRouter)
Vue.use(BootstrapVue)

var routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { title: 'ACRY PRO' }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: 'ホーム | ACRY PRO' }
  },
  {
    path: '/registmail',
    name: 'AcryProRegistMailAddress',
    component: AcryProRegistMailAddress,
    meta: { title: '新規登録 | ACRY PRO' }
  },
  {
    path: '/forgotpassword',
    name: 'AcryProForgotPassword',
    component: AcryProForgotPassword,
    meta: { title: 'パスワード再設定 | ACRY PRO' }
  },
  {
    path: '/acryproform',
    name: 'AcryProForm',
    component: AcryProForm,
    meta: { title: 'お客様情報登録 | ACRY PRO' }
  },
  {
    path: '/contract',
    name: 'AcryProContract',
    component: AcryProContract,
    meta: { title: '契約書送信 | ACRY PRO' }
  },
  {
    path: '/contact',
    name: 'ContactForm',
    component: ContactForm,
    meta: { title: 'お問い合わせ | ACRY PRO' }
  },
  {
    path: '/contactcomplete',
    name: 'ContactFormComplete',
    component: ContactFormComplete,
    meta: { title: 'お問い合わせ送信完了 | ACRY PRO' }
  },

  { path: '*', name: 'NotFound' }, // キャッチオール
]

import 'bootstrap/dist/css/bootstrap.css' // added
import 'bootstrap-vue/dist/bootstrap-vue.css' // added

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeResolve((to, from, next) => {
  if (to.path == '/' || to.path == '/registmail' || to.path == '/forgotpassword' || to.path == '/contact') {
    next()
  } else {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next()
      } else {
        next({path: '/'})
        // next()
      }
    })
  }
})

const DEFAULT_TITLE = 'ACRY PRO'
function resolveTitle(to) {
  // ネストされた子ルートほど後ろになるので、最後に meta.title を持っているものを採用
  const lastWithTitle = [...to.matched].reverse().find(r => r.meta && r.meta.title)
  return (lastWithTitle && lastWithTitle.meta.title) || DEFAULT_TITLE
}

router.beforeEach((to, from, next) => {
  // 存在しないページの場合
  if( to.name == "NotFound" ){
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next({path: '/home'})
      } else {
        next({path: '/'})
      }
    })
  }
  next();
  // if (to.name === 'NotFound') {
  // }
});

router.afterEach((to) => {
  console.log(to);
  Analytics.pageView(to.fullPath);
  Vue.nextTick(() => { document.title = resolveTitle(to) })
});

export default router
